import {
  MOSTRAR_LOADING,
  FECHAR_LOADING
} from '../actions/types'

const ESTADO_INICIAL = { loading: false, qtdOperacoesEmAndamento: 0 }
const initialState = undefined

export default function (state = ESTADO_INICIAL, action = initialState) {
  let qtd = state.qtdOperacoesEmAndamento
  switch (action.type) {
    case MOSTRAR_LOADING: {
      qtd += 1
      return { loading: true, qtdOperacoesEmAndamento: qtd }
    }

    case FECHAR_LOADING: {
      qtd -= 1

      if (qtd > 0) {
        return { loading: true, qtdOperacoesEmAndamento: qtd }
      }

      return { loading: false, qtdOperacoesEmAndamento: qtd }
    }

    default:
      return state
  }
}
